import { render, staticRenderFns } from "./DriverEfficiency.vue?vue&type=template&id=72551860&scoped=true&"
import script from "./DriverEfficiency.vue?vue&type=script&lang=js&"
export * from "./DriverEfficiency.vue?vue&type=script&lang=js&"
import style0 from "./DriverEfficiency.vue?vue&type=style&index=0&id=72551860&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72551860",
  null
  
)

export default component.exports